import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import Field from '../components/Field';
import { fieldShape } from '../shapes';

const ContactInformation = ({ fields, touchField, updateField, noAutofill }) => (
  <div>
    <div className="c-heading c-heading--huge u-mb u-show-for-large-and-up">
      Contact Information
    </div>
    <div className="c-heading c-heading--huge u-mt u-mb- u-text-center u-hide-for-large-and-up">
      Contact Information
    </div>
    <form className="layout layout--flush u--ml- large-and-up--ml">
      { fields.map(field => (
        <div
          key={field.id}
          className={classnames(
            'layout__item u-pl- large-and-up-pl u-mb- large-and-up-mb',
            { 'u-1/1': field.fullWidth,
              'u-1/2-small-plus-and-up': !field.fullWidth },
          )}
        >
          <Field
            id={field.id}
            label={field.label}
            errorMessage={field.errorMessage}
            autoComplete={noAutofill ? 'off' : field.autoComplete}
            name={field.name}
            required={field.required}
            onChange={updateField(field)}
            onBlur={touchField(field)}
            type={field.type}
            error={field.error}
            value={field.value}
          />
        </div>
      ))}
    </form>
  </div>
);
ContactInformation.propTypes = {
  fields: PropTypes.arrayOf(fieldShape),
  touchField: PropTypes.func,
  updateField: PropTypes.func,
  noAutofill: PropTypes.bool,
};
ContactInformation.defaultProps = {
  fields: [],
  touchField: null,
  updateField: null,
  noAutofill: false,
};

export default ContactInformation;



// WEBPACK FOOTER //
// ./src/app/components/ContactInformation.jsx